module.exports = "/assets/data/6e87939ff00769b486fb3addeeee936f-B98.data.json";